import * as React from "react"
import { Star } from "lucide-react"
import { cn } from "@/lib/utils"

interface StarRatingProps {
  maxRating?: number
  rating?: number
  disabled?: boolean
  onRate?: (rating: number) => void
  className?: string
}

function StarRating({
  maxRating = 5,
  rating = 0,
  disabled = true,
  onRate,
  className,
}: StarRatingProps) {
  return (
    <span className={cn("inline-flex gap-0.5", className)}>
      {Array.from({ length: maxRating }, (_, i) => (
        <Star
          key={i}
          className={cn(
            "h-4 w-4",
            i < rating
              ? "fill-yellow-400 text-yellow-400"
              : "text-gray-300",
            !disabled && "cursor-pointer hover:text-yellow-400"
          )}
          onClick={!disabled && onRate ? () => onRate(i + 1) : undefined}
        />
      ))}
    </span>
  )
}

export { StarRating }
